// accountContext.js
// Centralized account context and selection logic for all pages

import axios from 'axios';

/**
 * Get acctNo from URL query string
 */
export function getAcctNoFromUrl(search) {
  if (!search) return null;
  const params = new URLSearchParams(search);
  return params.get('acc') || null;
}

/**
 * Get acctNo from localStorage
 */
export function getAcctNoFromLocalStorage() {
  return localStorage.getItem('acctNo') || null;
}

/**
 * Set acctNo and acctId in localStorage
 * @param {string} acctNo
 * @param {string} acctId
 */
export function setAcctNoInLocalStorage(acctNo, acctId) {
  if (acctNo) localStorage.setItem('acctNo', acctNo);
  if (acctId) localStorage.setItem('acctId', acctId);
}

/**
 * Get acctId from backend using acctNo
 */


/**
 * Update URL with new acctNo
 */
export function updateUrlWithAcctNo(acctNo, location, navigate) {
  if (!acctNo || !location || !navigate) return;
  const params = new URLSearchParams(location.search);
  params.set('acc', acctNo);
  navigate({ search: params.toString() });
}

/**
 * Validate account access (returns true/false)
 */
export async function validateAccountAccess(acctNo, token) {
  if (!acctNo) return false;
  try {
    const response = await axios.get(`/api/ui/appointment/gCal/verifyAccountAccess/${acctNo}`, {
      headers: { Authorization: token ? `Bearer ${token}` : undefined }
    });
    return response.status === 200;
  } catch {
    return false;
  }
}

/**
 * Get accounts list from backend (by userId)
 */
export async function getAccountsList(userId, token) {
  if (!userId || !token) return [];
  try {
    const response = await axios.get(`/api/ui/appointment/gCal/accountName/${userId}`, {
      headers: { Authorization: `Bearer ${token}` }
    });
    if (response.data && response.data.success && Array.isArray(response.data.accounts)) {
      return response.data.accounts;
    }
    return [];
  } catch {
    return [];
  }
}
